var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-seoGame",
      style: { "background-image": "url(" + _vm.backgroundImage + ")" }
    },
    [
      _c("v-container", [
        _c("div", { staticClass: "page-seoGame__container" }, [
          _c("div", { staticClass: "page-seoGame__header" }, [
            _c("div", { staticClass: "logoGame" }, [
              _c("picture", [
                _c("source", {
                  attrs: {
                    srcset:
                      _vm.game.bigCoverImage && _vm.game.bigCoverImage.webp,
                    type: "image/webp"
                  }
                }),
                _c("img", {
                  ref: "image",
                  attrs: {
                    src: _vm.game.bigCoverImage && _vm.game.bigCoverImage.jpg,
                    alt: _vm.game.title
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "inf" }, [
              _c("div", { staticClass: "inf-text" }, [
                _c("h1", [_vm._v(_vm._s(_vm.game.title))]),
                _c("p", [_vm._v(_vm._s(_vm.game.platformTitle))])
              ]),
              _c(
                "div",
                { staticClass: "inf-buttons" },
                [
                  _vm.isPlayForFunAllowed
                    ? _c(
                        "router-link",
                        {
                          staticClass: "btn-free",
                          attrs: { to: _vm.gamePlayFunUrl, event: "" },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.playForFun($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("front.game.button.play_free")) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.game.playForReal
                    ? _c(
                        "router-link",
                        {
                          staticClass: "btn-play",
                          attrs: { to: _vm.gamePlayRealUrl, event: "" },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.playForReal($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("front.game.button.play_real")) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _c("div", { staticClass: "page-seoGame__content" }, [
            _c("p", [
              _c("span", { staticClass: "box-info" }, [
                _c("span", { staticClass: "box-info__rate" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "19",
                        height: "18",
                        viewBox: "0 0 19 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("g", { attrs: { "clip-path": "url(#clip1)" } }, [
                        _c("path", {
                          attrs: {
                            d:
                              "M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z",
                            fill: "#FBC763"
                          }
                        })
                      ]),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip1" } }, [
                          _c("rect", {
                            attrs: {
                              width: "17.6147",
                              height: "17.6147",
                              fill: "white",
                              transform: "translate(0.724854 0.0449219)"
                            }
                          })
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "19",
                        height: "18",
                        viewBox: "0 0 19 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("g", { attrs: { "clip-path": "url(#clip2)" } }, [
                        _c("path", {
                          attrs: {
                            d:
                              "M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z",
                            fill: "#FBC763"
                          }
                        })
                      ]),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip2" } }, [
                          _c("rect", {
                            attrs: {
                              width: "17.6147",
                              height: "17.6147",
                              fill: "white",
                              transform: "translate(0.724854 0.0449219)"
                            }
                          })
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "19",
                        height: "18",
                        viewBox: "0 0 19 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("g", { attrs: { "clip-path": "url(#clip3)" } }, [
                        _c("path", {
                          attrs: {
                            d:
                              "M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z",
                            fill: "#FBC763"
                          }
                        })
                      ]),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip3" } }, [
                          _c("rect", {
                            attrs: {
                              width: "17.6147",
                              height: "17.6147",
                              fill: "white",
                              transform: "translate(0.724854 0.0449219)"
                            }
                          })
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "19",
                        height: "18",
                        viewBox: "0 0 19 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("g", { attrs: { "clip-path": "url(#clip4)" } }, [
                        _c("path", {
                          attrs: {
                            d:
                              "M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z",
                            fill: "#FBC763"
                          }
                        })
                      ]),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip4" } }, [
                          _c("rect", {
                            attrs: {
                              width: "17.6147",
                              height: "17.6147",
                              fill: "white",
                              transform: "translate(0.724854 0.0449219)"
                            }
                          })
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "19",
                        height: "18",
                        viewBox: "0 0 19 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("g", { attrs: { "clip-path": "url(#clip5)" } }, [
                        _c("path", {
                          attrs: {
                            d:
                              "M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z",
                            fill: "#FBC763"
                          }
                        })
                      ]),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip5" } }, [
                          _c("rect", {
                            attrs: {
                              width: "17.6147",
                              height: "17.6147",
                              fill: "white",
                              transform: "translate(0.724854 0.0449219)"
                            }
                          })
                        ])
                      ])
                    ]
                  )
                ]),
                _c("img", {
                  attrs: { src: _vm.logotypePath, alt: _vm.appName }
                }),
                _c("span", { staticClass: "box-info__desc" }, [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.$t("front.game.info.review")))
                  ]),
                  _c("span", { staticClass: "date" }, [
                    _c("span", { staticClass: "date-start" }, [
                      _vm._v(
                        _vm._s(_vm.$t("front.game.info.created")) +
                          " " +
                          _vm._s(_vm.createdAt)
                      )
                    ]),
                    _c("span", { staticClass: "date-update" }, [
                      _vm._v(
                        _vm._s(_vm.$t("front.game.info.updated")) +
                          " " +
                          _vm._s(_vm.updatedAt)
                      )
                    ])
                  ])
                ])
              ]),
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.game.description) }
              })
            ])
          ])
        ]),
        _vm.relatedGames.length
          ? _c(
              "div",
              { staticClass: "related-games" },
              [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("front.game.titles.related_games")))
                ]),
                _c(
                  "swiper",
                  _vm._b(
                    { ref: "swiperSS", attrs: { options: _vm.settings } },
                    "swiper",
                    _vm.settings,
                    false
                  ),
                  _vm._l(_vm.relatedGames, function(item, index) {
                    return _c(
                      "swiper-slide",
                      { key: index },
                      [
                        _c("game-item", {
                          staticClass: "listGame__list-item",
                          attrs: { item: item }
                        })
                      ],
                      1
                    )
                  }),
                  1
                ),
                _c("div", {
                  staticClass: "swiper-button-next swiper-button-white",
                  attrs: { id: "button-next-relacionados" },
                  on: {
                    click: function($event) {
                      return _vm.swiperNext()
                    }
                  }
                }),
                _c("div", {
                  staticClass: "swiper-button-prev swiper-button-white",
                  attrs: { id: "button-prev-relacionados" },
                  on: {
                    click: function($event) {
                      return _vm.swiperPrev()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("script", {
        attrs: { type: "application/ld+json" },
        domProps: { innerHTML: _vm._s(_vm.jsonLdReviewType) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }